export const TawkToConfig = {
    propertyId: process.env.REACT_APP_TAWKTO_PROPERTY,
    widgetId: process.env.REACT_APP_TAWKTO_WIDGET,
}